// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"171":"22f863d9","286":"06ac518d","743":"fd13a00b","917":"3491d676"}[chunkId] + ".chunk.js";
};